const ProductQueryKey = {
  PRODUCTS: 'PRODUCTS',
  PRODUCT_DETAIL: 'PRODUCT_DETAIL',
  PRODUCT_SIMILAR: 'PRODUCT_SIMILAR',
};

export default ProductQueryKey;
